import { currencySchema } from "../../../payment/shared.mjs";
import { orpcSuccessVoidResponseSchema } from "../util/success.mjs";
import { purchaseInputSchema, purchaseResultSchema, surprisePackSKUSchema, userSurprisePackSchema } from "../payment/surprisePack/schemas.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/event/surprisePack.ts
const ListFilter = {
	ALL: "all",
	PURCHASABLE: "purchasable"
};
const listFilterValues = Object.values(ListFilter);
const listFilterSchema = z.enum(listFilterValues);
const listInputSchema = z.object({
	eventName: z.string(),
	currency: currencySchema.optional(),
	filter: listFilterSchema.optional().default(ListFilter.ALL)
});
const resetInputSchema = z.object({ eventName: z.string() });
const surprisePackContract = oc.prefix("/event/{eventName}/surprise-pack").tag("SurprisePack").router({
	list: oc.route({
		method: "GET",
		path: "/",
		summary: "List available surprise pack SKUs"
	}).input(listInputSchema).output(z.object({ data: z.array(surprisePackSKUSchema) })),
	userPacks: oc.route({
		method: "GET",
		path: "/user-packs",
		summary: "Get current user surprise pack records"
	}).input(z.object({ eventName: z.string() })).output(z.object({ data: z.array(userSurprisePackSchema) })),
	purchase: oc.route({
		method: "POST",
		path: "/purchase",
		summary: "Purchase a surprise pack"
	}).input(purchaseInputSchema).output(purchaseResultSchema).errors({
		PACK_NOT_FOUND: {
			status: 404,
			message: "Surprise pack SKU not found"
		},
		PACK_NOT_ACTIVE: {
			status: 400,
			message: "Surprise pack is not active"
		},
		EVENT_NOT_IN_WINDOW: {
			status: 400,
			message: "Event is not in the active time window"
		},
		PURCHASE_LIMIT_REACHED: {
			status: 409,
			message: "Purchase limit reached for this pack type"
		}
	}),
	reset: oc.route({
		method: "POST",
		path: "/reset",
		summary: "Delete all user surprise packs for a given event (admin only)"
	}).input(resetInputSchema).output(orpcSuccessVoidResponseSchema)
});
//#endregion
export { ListFilter, surprisePackContract };
